import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogAssignComponent } from '../assign/dialog.component.assign';
import { IOwner, IOwnerResponse } from '../../owners/owners.interfaces';

import { DatePipe } from '@angular/common';
import { OwnService } from '../../services/owners/own.service';
import { VehService } from '../../services/vehicles/veh.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-data-own',
  templateUrl: './dialog.component.own.html',
  styleUrls: ['./dialog.component.own.scss'],
  providers: [ DatePipe, OwnService, VehService ]
})

export class DialogOwner {
  private id: string;
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editOwnerData: IOwner;
  
  public userInfo: any = {};
  public idList: any[];
  public idType: any[];
  public idName: any[];
 
   public filterStates(val: string) {
  }

  constructor(private datePipe: DatePipe, public dialog:MatDialog, public dialogRef: MatDialogRef<DialogOwner>, @Inject(MAT_DIALOG_DATA) public data: any, public ownService: OwnService, public vehService: VehService){ 
   this.editOwnerData =  data.dades;
   this.ownService.getAutocomplete("id").subscribe(result => {this.idList = result;});
   this.ownService.getAutocomplete("name").subscribe(result => {this.idName = result;});
   this.ownService.getAutocomplete("type").subscribe(result => {this.idType = result;});

   this.userInfo = data.user;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editOwnerData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  afegir(event){
    if(event){
      this.id = event.value;
    }
  }

  setAny(event, picker) {
    this.data.setFullYear(event.year());
    picker.close();
  }

  public assignVehicles(id: string): void {
    this.ownService.getByOwner(id).subscribe(data => {
      const dialogRef = this.dialog.open(DialogAssignComponent, {
        width: '500px',
        data: {
          mode: 'owner-to-vehicle',
          id: id,
          currentAssignments: data
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (!result) return;
        this.ownService.setVehiclesForOwner(id, result).subscribe();
      });
    });
  }

  ngOnInit(){ }
}
